import React from 'react'

import poorvikaLogoRectangle from 'assets/Poorvika-rectangle.png'

const BrandLogo: React.FC = () => {
  return <img alt="logo rectangle"  className="login-logo"  draggable="false" src={poorvikaLogoRectangle} width= '150px' />
}

export default BrandLogo
